var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGps = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 3C6.51335 3 4.5 5.01595 4.5 7.5C4.5 9.1668 5.06229 9.68768 8.04541 14.4709C8.48569 15.1768 9.5148 15.1759 9.95456 14.4709C12.9393 9.68517 13.5 9.16648 13.5 7.5C13.5 5.01335 11.484 3 9 3ZM9 13.875C6.0135 9.08639 5.625 8.78409 5.625 7.5C5.625 5.63604 7.13604 4.125 9 4.125C10.864 4.125 12.375 5.63604 12.375 7.5C12.375 8.77859 12.0195 9.0334 9 13.875ZM7.125 7.5C7.125 6.46446 7.96446 5.625 9 5.625C10.0355 5.625 10.875 6.46446 10.875 7.5C10.875 8.53554 10.0355 9.375 9 9.375C7.96446 9.375 7.125 8.53554 7.125 7.5Z",
  fill: "currentColor"
})));
export default SvgGps;